function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
export function useSize(deviationMediaService, attrs, options, containerWidth) {
    var _attrs_width;
    const width = (_attrs_width = attrs.width) !== null && _attrs_width !== void 0 ? _attrs_width : undefined;
    var _attrs_height;
    const height = (_attrs_height = attrs.height) !== null && _attrs_height !== void 0 ? _attrs_height : undefined;
    containerWidth = containerWidth - 32;
    const fv = deviationMediaService.getLargestFullview(attrs.deviation);
    if (!fv) {
        return {
            width: 50,
            height: 50
        };
    }
    var _fv_height, _fv_width;
    const ratio = ((_fv_height = fv.height) !== null && _fv_height !== void 0 ? _fv_height : 0) / ((_fv_width = fv.width) !== null && _fv_width !== void 0 ? _fv_width : 0);
    // Set dims
    if (!isNaN(width) && !isNaN(height)) {
        var _options_maxWidth, _options_maxHeight;
        return {
            width: clamp(clamp(attrs.width, 0, (_options_maxWidth = options.maxWidth) !== null && _options_maxWidth !== void 0 ? _options_maxWidth : Infinity), 0, containerWidth),
            height: clamp(attrs.height, 0, (_options_maxHeight = options.maxHeight) !== null && _options_maxHeight !== void 0 ? _options_maxHeight : Infinity)
        };
    }
    // Width only
    if (!isNaN(width) && isNaN(height)) {
        var _options_maxWidth1, _options_maxHeight1;
        return {
            width: clamp(clamp(attrs.width, 0, (_options_maxWidth1 = options.maxWidth) !== null && _options_maxWidth1 !== void 0 ? _options_maxWidth1 : Infinity), 0, containerWidth),
            height: clamp(attrs.width * ratio, 0, (_options_maxHeight1 = options.maxHeight) !== null && _options_maxHeight1 !== void 0 ? _options_maxHeight1 : Infinity)
        };
    }
    var _options_maxWidth2, _options_maxHeight2;
    // Defaults
    return {
        width: clamp(clamp(options.defaultWidth, 0, (_options_maxWidth2 = options.maxWidth) !== null && _options_maxWidth2 !== void 0 ? _options_maxWidth2 : Infinity), 0, containerWidth),
        height: clamp(options.defaultWidth * ratio, 0, (_options_maxHeight2 = options.maxHeight) !== null && _options_maxHeight2 !== void 0 ? _options_maxHeight2 : Infinity)
    };
}

//# sourceMappingURL=useSize.js.map